module.exports = __webpack_public_path__ + "media/application/images/demo/top-e4209f4bb6c6af4586028999bd15758f.jpg";